<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
  <span>Confirm Action</span>
  <i class="fa fa-times model_close cursor-pointer" (click)="closeDialog(false)"></i>
</h1>

<div mat-dialog-content class="popup-content">
  Are you sure, want to delete ?</div>
<div mat-dialog-actions class=" popup-buttons d-flex justify-content-end">
  <button [mat-dialog-close]="true" class="custom_btn primary_btn_base" (click)="deleteTemplate()">Delete</button>
  <button mat-dialog-close class="custom_btn inverted_btn_base ml-2" (click)="closeDialog(false)">Cancel</button>
</div>